module.exports = __webpack_public_path__ + "web/img/s6.4ba0e705.png";